import { put, call, fork, takeMaybe } from 'redux-saga/effects'
import { getCourseCollectionService } from 'src/api/collection'
import { getCollectionSuccess } from 'src/reducers/collection/action'
import { GET_COLLECTION } from 'src/reducers/collection/type'
import generalSaga from '../general'
import { operationSuccess, operationFail } from 'src/reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* getCollectionFlow(payload) {
  try {
    const { id, callback } = payload
    const response = yield call(getCourseCollectionService, id)

    yield put(getCollectionSuccess(response.data))
    yield put(operationSuccess())

    if (callback) callback(response.data)
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* getCollectionWatcher() {
  while (true) {
    const action = yield takeMaybe(GET_COLLECTION)
    const { payload } = action

    // Page loads show their own loading state; no full-screen overlay.
    yield fork(generalSaga, getCollectionFlow, payload, false)
  }
}
